import axiosWrapper from './axiosWrapper';

/**
 * Scene version history (delta-based, reconstructed server-side).
 */
const revisionService = {
  /** Newest-first list of revisions: seq, kind, wordCount, authorName, note, dates. */
  async listRevisions(sceneId) {
    return axiosWrapper({
      method: 'get',
      path: `scenes/${encodeURIComponent(sceneId)}/revisions`,
    });
  },

  /** Full reconstructed editor state at one revision. */
  async getRevisionState(sceneId, seq) {
    return axiosWrapper({
      method: 'get',
      path: `scenes/${encodeURIComponent(sceneId)}/revisions/${seq}`,
    });
  },

  /** Restore the scene to a revision. The pre-restore content is kept as a new revision. */
  async restoreRevision(sceneId, seq) {
    return axiosWrapper({
      method: 'post',
      path: `scenes/${encodeURIComponent(sceneId)}/revisions/${seq}/restore`,
    });
  },
};

export default revisionService;
